"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    _classCallCheck(this, Component);
    return _callSuper(this, Component, arguments);
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.values = this.props.values;
      if (this.props.showErrorsImmediately) {
        this.props.handleSubmit();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        values = _this$props.values,
        isValid = _this$props.isValid,
        isValidating = _this$props.isValidating,
        onValidChange = _this$props.onValidChange,
        onAnyChange = _this$props.onAnyChange;

      // Update submit countter if we need to show all errors
      if (!prevProps.showErrorsImmediately && this.props.showErrorsImmediately) {
        this.props.handleSubmit();
      }
      if (!onValidChange && !onAnyChange) {
        return;
      }
      if (onValidChange && isValid && !isValidating && !(0, _isEqual2["default"])(this.values, values)) {
        this.values = values;
        onValidChange(this.props.prepareValues(values));
      }
      if (onAnyChange && !(0, _isEqual2["default"])(prevProps.values, values)) {
        onAnyChange(this.props.prepareValues(values));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  onValidChange: _propTypes["default"].func,
  onAnyChange: _propTypes["default"].func,
  prepareValues: _propTypes["default"].func,
  values: _propTypes["default"].object,
  isValid: _propTypes["default"].bool,
  isValidating: _propTypes["default"].bool,
  handleSubmit: _propTypes["default"].func,
  showErrorsImmediately: _propTypes["default"].bool
});